<template>
  <div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>
          บัญชีแสดงสัญญา
          <span class="required">*</span>
        </label>
        <b-form-input @keypress="isNumber($event)"
          v-model="caNo"
          name="caNo"
          type="text"      
          v-validate="{required:true}"  
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('caNo') }"
          maxlength="12"
        ></b-form-input>
      </div>
      <div class="form-group col-md-6">
        <label>เลขที่คำขอเงินประกัน</label>
        <span class="required">*</span>
        <input @keypress="isNumber($event)"
          v-model="securityNo"
          name="securityNo"
          type="text"
          class="form-control"
          v-validate="{required:true}"  
          :disabled="this.reqType !== 1  && this.appVo.bcFlag !=='1' && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('securityNo') }"
          maxlength="10"
        >
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>หมายเลขคู่ค้าทางธุรกิจ</label>
        <span class="required">*</span>
        <input @keypress="isNumber($event)"
          v-model="bpNo"
          name="bpNo"
          type="text"
          class="form-control"
          v-validate="{required:true}"  
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('bpNo') }"
          maxlength="10"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  props: ["reqType","appVo"],
  data() {
    return {
      caNo: "",
      securityNo: "",
      bpNo: "",
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.caNo = this.appVo.caNo;
      //this.securityNo = this.appVo.securityNo;
      this.bpNo = this.appVo.bpNo;
    }
  },
  watch: {
    caNo(newDate, oldDate) {
      this.$emit("childToParent", {
        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo
      });
    },
    securityNo(newDate, oldDate) {
      this.$emit("childToParent", {
        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo
      });
    },
    bpNo(newDate, oldDate) {
      this.$emit("childToParent", {
        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo
      });
    },
    
  },
  methods: {
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
  }
};
</script>